/*
 * @Author: liyxt
 * @Date: 2020-05-28 11:40:24
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:46:29
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginDropdown from 'bee-dropdown';
import { getSysFieldid } from '@platform/api';

require('bee-dropdown/build/Dropdown.css');
require('./index.less');

class Dropdown extends Component {
	constructor(props) {
		super(props);
	}
	render() {
		let { overlayClassName, fieldid, ...others } = this.props;

		if (getSysFieldid(fieldid)) {
			if (overlayClassName) {
				overlayClassName = overlayClassName + ` fieldid_${fieldid}_btn_list`
			} else {
				overlayClassName = `fieldid_${fieldid}_btn_list`
			}
		}
		return (
			<OriginDropdown
				overlayClassName={`nc-dropdown ${overlayClassName ? ' ' + overlayClassName : ''}`}
				{...others}
			/>
		);
	}
}
export default Dropdown;
